import { ref } from 'vue'
import { useRouter, type RouteLocationRaw } from 'vue-router'
import { closeToast, showLoadingToast } from 'vant'
import { agentApplicationPendingApi } from '@/api/agent'
import { useAssetsStore } from '@/stores/assets'

export type AgentEntryOptions = {
  /** 已是一级码商时的跳转目标 */
  certifiedTo?: RouteLocationRaw
}

/**
 * 「成为商家 / 认证商家」入口导航：
 * - 二级码商：不跳转
 * - 一级码商：跳 certifiedTo（默认商家页）
 * - 普通会员：查 pending，审核中直达对应页，否则进 guide
 */
export function useAgentEntryNavigation() {
  const router = useRouter()
  const assetsStore = useAssetsStore()
  const navigating = ref(false)

  async function navigateToAgentEntry(options: AgentEntryOptions = {}) {
    const agentLevel = assetsStore.userProfile?.agent_level
    if (agentLevel == 2) return

    if (agentLevel == 1) {
      router.push(options.certifiedTo ?? '/user/business')
      return
    }

    if (navigating.value) return
    navigating.value = true
    showLoadingToast({ message: '加载中...', forbidClick: true })
    try {
      const res = await agentApplicationPendingApi()
      const pendingType = res.data?.pending_type ?? 0
      if (pendingType == 1) {
        router.push('/user/business')
      } else if (pendingType == 2) {
        const code = res.data?.code?.trim()
        router.push(
          code ? { path: '/user/invitation-code', query: { code } } : '/user/invitation-code',
        )
      } else {
        router.push('/user/agent-guide')
      }
    } catch {
      router.push('/user/agent-guide')
    } finally {
      closeToast()
      navigating.value = false
    }
  }

  return { navigating, navigateToAgentEntry }
}
